import * as e from "react";
import { forwardRef as l } from "react";
const h = l(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          fill: "#FFCA00",
          height: 9.77778,
          rx: 2.44444,
          width: 9.77778,
          x: 0.5,
          y: 0.5
        }
      ),
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          fill: "#FFCA00",
          height: 9.77778,
          rx: 2.44444,
          width: 9.77778,
          x: 12.7222,
          y: 0.5
        }
      ),
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          fill: "#FFCA00",
          height: 9.77778,
          rx: 2.44444,
          width: 9.77778,
          x: 12.7222,
          y: 12.7222
        }
      ),
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          fill: "#FFCA00",
          height: 9.77778,
          rx: 2.44444,
          width: 9.77778,
          x: 0.5,
          y: 12.7222
        }
      )
    );
  }
);
export {
  h as BetBuilderBadgeAllActive
};
